var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2504 14.8853L6.5096 11.6261L8.86661 13.9831L12.6759 10.1739L14.1699 11.668V7.5013H10.0033L11.4974 8.99538L8.86661 11.6261L6.5096 9.26904L2.38804 13.3906C1.92649 12.3551 1.66992 11.2082 1.66992 10.0013C1.66992 5.39893 5.40089 1.66797 10.0033 1.66797C14.6056 1.66797 18.3366 5.39893 18.3366 10.0013C18.3366 14.6037 14.6056 18.3346 10.0033 18.3346C7.22516 18.3346 4.76456 16.9752 3.2504 14.8853Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorBlack);
export default __webpack_public_path__ + "static/media/investor-black.df8f1b44fd95992a3e39cf09bd8ceee9.svg";
export { ForwardRef as ReactComponent };